import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { useThemeColors } from '@/hooks/useThemeColors'
import { InvoiceForm } from '@/components/forms/InvoiceForm'

export default function EditInvoicePage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const location = useLocation()
  const params = useParams<{ shippingLineId: string; soaId: string; invoiceId: string }>()
  const paramsShippingLineId = params.shippingLineId
  const soaId = params.soaId ? parseInt(params.soaId, 10) : undefined
  const invoiceId = params.invoiceId ? parseInt(params.invoiceId, 10) : undefined

  // Get data from navigation state or route params
  const navigationState = location.state as
    | {
        shippingLineName?: string
        shippingLineId?: string
        soaId?: number
        invoiceId?: number
      }
    | null
  const shippingLineName = navigationState?.shippingLineName || ''
  const finalShippingLineId =
    navigationState?.shippingLineId || paramsShippingLineId
  const finalSoaId = navigationState?.soaId || soaId
  const finalInvoiceId = navigationState?.invoiceId || invoiceId

  const handleSuccess = () => {
    navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
  }

  const handleCancel = () => {
    navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
  }

  return (
    <AdminLayout>
      <Box p={4} h="100%" overflow="auto">
        <Card>
          <CardHeader>
            <Heading size="md" mb={1}>
              Edit Invoice
            </Heading>
            <Text fontSize="sm" color={colors.text}>
              Update Invoice details
            </Text>
          </CardHeader>
          <CardBody>
            <InvoiceForm
              invoiceId={finalInvoiceId}
              soaId={finalSoaId}
              registeredName={shippingLineName}
              onSuccess={handleSuccess}
              onCancel={handleCancel}
            />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}

